import { apiHost } from '../../../config';
import { post } from '../../requests';
import Municipality from '../../../types/Municipality';

export default async function createMunicipality(
  municipality: Omit<Municipality, 'id'>,
) {
  return post(`${apiHost}/api/admin/municipalities`, municipality);
}
